import { gsap } from 'gsap';
import { lerp, map } from '../utils.js';

export default class HomeHeader {
	constructor(elm) {
		this.elm = elm;

		this.A = this.elm.querySelector('[data-home-header-a]');
		this.B = this.elm.querySelector('[data-home-header-b]');
		this.C = this.elm.querySelector('[data-home-header-c]');

		this.images = this.C.querySelectorAll('img');
		this.images.forEach((img) => {
			img.addEventListener('lazyloaded', () => {
				this.show();
			});
		});

		this.currentEvent = null;

		this.translationVals = {
			tx: 0,
			ty: 0,
		};

		this.xstart = 0;
		this.ystart = 0;

		this.calculateMouse = () => {
			if (!this.currentEvent) {
				return;
			}

			this.translationVals.tx = lerp(
				this.translationVals.tx,
				map(this.currentEvent.clientX, window.innerWidth * 0.05, window.innerWidth * 0.95, -1, 1),
				1
			).toFixed(2);

			this.translationVals.ty = lerp(
				this.translationVals.ty,
				map(this.currentEvent.clientY, window.innerHeight * 0.1, window.innerHeight * 0.9, -1, 1),
				1
			).toFixed(2);

			gsap.to(document.documentElement, {
				'--x': gsap.utils.clamp(-1, 1, this.translationVals.tx),
				'--y': gsap.utils.clamp(-1, 1, this.translationVals.ty),

				duration: 0.15,
				ease: 'sine.inOut',
			});
		};

		window.addEventListener('mousemove', (e) => {
			this.handleMousemove(e);
		});

		this.addTicker();
	}

	addTicker() {
		let mm = gsap.matchMedia();

		mm.add(
			{
				isDesktop: `(min-width: 992px)`,
				isMobile: `(max-width: 991px)`,
				reduceMotion: '(prefers-reduced-motion: reduce)',
				hasHover: '(hover: hover) and (pointer: fine)',
			},
			(context) => {
				let { isDesktop, isMobile, reduceMotion, hasHover } = context.conditions;

				if (reduceMotion) {
					return;
				}

				if (hasHover) {
					gsap.ticker.add(this.calculateMouse);
				} else {
					this.createMobileAnimation();
				}
			}
		);
	}

	show() {
		this.elm.classList.add('is-visible');
	}

	createMobileAnimation() {
		this.mobileAnimation = gsap.timeline({
			repeat: -1,
			yoyo: true,
		});

		this.mobileAnimation.to(document.documentElement, {
			'--x': -1,
			'--y': -1,

			duration: 2,
			ease: 'sine.inOut',
		});

		this.mobileAnimation.to(document.documentElement, {
			'--x': 1,
			'--y': 1,

			duration: 2,
			ease: 'sine.inOut',
		});

		this.mobileAnimation.to(document.documentElement, {
			'--x': -1,
			'--y': 1,

			duration: 2,
			ease: 'sine.inOut',
		});

		this.mobileAnimation.to(document.documentElement, {
			'--x': 1,
			'--y': -1,

			duration: 2,
			ease: 'sine.inOut',
		});
	}

	removeTicker() {
		gsap.ticker.remove(this.calculateMouse);
	}

	handleMousemove(e) {
		this.currentEvent = e;
	}

	destroy() {
		window.removeEventListener('mousemove', this.boundHandleMousemove);
		this.removeTicker();
	}
}
